import { Button } from "@mui/material";
import React from "react";

const action = (onClose) =>
  <React.Fragment>
    <Button style={{ textTransform: 'capitalize' }} color="secondary" size="small" onClick={() => onClose()}>Close</Button>
  </React.Fragment>;

export { action }
